import { marked } from 'marked';
import { applyCustomClasses } from './applyCustomClasses';

export const parseAndStyleResponse = (content) => {
    let parsedContent = marked.parse(content);

    parsedContent = applyCustomClasses(parsedContent);

    return parsedContent;
};
